import { Button } from "@components/button";
import { PlymouthIcon } from "@components/icons";
import { useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { MainNav, PageOptions } from "./main";
import TeamSwitcher, { TeamSwitcherLabel } from "./teamSwitcher";

const Navbar = () => {
  const location = useLocation();
  const nav = useNavigate();
  const currentPage = useMemo(() => {
    const page = location.pathname.split("/")[1];
    if (page === "") {
      return "home";
    }
    console.log(location.pathname);
    if (location.pathname.includes("onboarding/beneficiary")) {
      return "home";
    }
    return page as PageOptions;
  }, [location]);

  return (
    <div className="relative z-10 bg-[#F7FCFF] flex flex-col items-center gap-y-4 h-full py-5 px-4 border border-[#F1F1F1]">
      <Button
        variant="ghost"
        size="icon"
        className="w-11 h-11 hover:bg-transparent mb-4"
        onClick={() => nav("/")}
      >
        <div className="h-8 w-8">
          <PlymouthIcon />
        </div>
      </Button>
      <TeamSwitcherLabel />
      <MainNav selectedPage={currentPage} />
      <div className="mt-auto flex flex-row gap-x-2">
        <TeamSwitcher />
      </div>
    </div>
  );
};

export default Navbar;
